<template>
    <div style="width: 100%;height: 100%;overflow:auto;">
        <van-nav-bar title="会员信息" left-text="返回" left-arrow @click-left="historyBack"/>
        <el-timeline style="margin-top: 10px;padding: 10px;">
                <el-timeline-item :timestamp="item.accountdate" placement="top" v-for="(item,key) in orderInfos" :key="key">
                    <el-card v-for="(val,idx) of item.saveOrderVos" :key="idx" style="width: 95%;color: #1989fa;">
                        
                        <el-row style="margin-bottom: 5px;">
                            <el-col :span="12">房间:{{val.orderInfo.roomname}}</el-col>
                            <el-col :span="12" class="custBtn" style="text-align: right;"><el-button type="primary" icon="el-icon-s-custom" size="mini" circle @click.stop="openBeautyLog(val.orderInfo)"></el-button></el-col>
                        </el-row>
                        <el-row style="margin-bottom: 5px;">
                            <el-col :span="8">姓名:{{val.orderInfo.membername}}</el-col>
                            <el-col :span="11">卡号:{{val.orderInfo.cardnumber}}</el-col>
                            <el-col :span="5">性别:<span v-if="val.orderInfo.sex==1">男</span><span v-else>女</span></el-col>
                        </el-row>
                        
                        <el-row style="margin-bottom: 5px;">
                            <el-col :span="24">时间段:{{val.orderInfo.times.split(",")[0]}}到{{val.orderInfo.times.split(",")[val.orderInfo.times.split(",").length-1]}}</el-col>
                        </el-row>
                        <el-row style="margin-bottom: 5px;">
                            <el-col :span="24">
                                需要做的项目:<span v-for="(detal,index) in val.orderDetals">({{detal.projectname}})</span>
                            </el-col>
                        </el-row>
                        <el-row style="margin-bottom: 5px;">
                            <el-col :span="24">
                                消费目标:{{val.orderInfo.xhtarget}}
                            </el-col>
                        </el-row>
                    </el-card>
                </el-timeline-item>
        </el-timeline>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                orderInfos:[],
                staffid:"",
                storeid:localStorage.getItem("storeid")
            }
        },
        created: function () {
            this.staffid=this.$route.query.staffid;
            this.getOrderByStaff();
        },
        methods: {
            openBeautyLog(row){
                this.$router.push({path:"/beautylog",query:{
                    cardid:row.cardid,
                    cardnumber:row.cardnumber,
                    memberid:row.memberid,
                    sex:row.sex,
                    memberphone:row.memberphone,
                    membername:row.membername,
                    cardtypeid:row.cardtypeid
                }});
            },
            getOrderByStaff(){
                this.$post("beautymanager/getOrderByStaff",{storeid:this.storeid,staffid:this.staffid}).then(res=>{
                    if(res.sucess){
                        this.orderInfos=res.object;
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            }
        }
    }
</script>
<style style lang="scss" rel="stylesheet/scss">
    .custBtn .el-button--mini.is-circle{
        padding:4px;
    }
</style>



// WEBPACK FOOTER //
// src/page/beauty/myorder.vue